module.exports = __webpack_public_path__ + "static/media/Amortizacion-Pago.a2f736e3.png";